import weekmenu from "./weekmenuReducer"
// import allWeekmenus from "./allWeekmenusReducer"

export default {
    weekmenu,
    // allWeekmenus,
}
